import React, { useEffect } from 'react';
import { useNavigate,useLocation } from 'react-router-dom';

function PagenavigatorComponent() {
    const location = useLocation();
    const {  search} = location;
    const searchParams = new URLSearchParams(search);
    const formqueryParams = searchParams.get('formtype');
    const navigate = useNavigate();
   
    useEffect(() => {
         if(formqueryParams==="YE"){
        navigate('/yearend');
         }
        else{
          navigate('/payroll');   

        }
    }, [formqueryParams, navigate]);


    return (
        <div>
            { }
        </div>
    );
}

export default PagenavigatorComponent;